export default "__VITE_ASSET__mgS8TAMz__"